import {RootStore} from "./RootStore";

export class BrowserSyncAdapter {
  private rootStore: RootStore;
  private unsubscribe: (() => void) | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  setupBrowserSync() {
    const handlePopState = () => {
      const pathname = window.location.pathname;
      this.rootStore.syncBreadcrumbsWithBrowser(pathname);
    };

    window.addEventListener('popstate', handlePopState);

    this.unsubscribe = () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }

  destroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
}
